<div class="tuning-details-wrapper">
    @if (pureOriginalsService.tableIsLoading()) {
    <app-pure-original-matching-details-skeleton></app-pure-original-matching-details-skeleton>
    }
    <div class="tuning-details-container" *ngIf="!pureOriginalsService.tableIsLoading()">
        <div class="tabs-bar">
            <button class="tab-pill" [ngClass]="selectedTab() === 'completed' ? 'active' : ''"
                (click)="selectTab('completed')">
                Completed ({{ completedList().length }})
            </button>
            <button class="tab-pill" [ngClass]="selectedTab() === 'partial' ? 'active' : ''"
                (click)="selectTab('partial')">
                Partially Tuned ({{ partialList().length }})
            </button>
            <button class="tab-pill" [ngClass]="selectedTab() === 'missing' ? 'active' : ''"
                (click)="selectTab('missing')">
                Missing Tunings ({{ missingList().length }})
            </button>
            <button class="tab-pill" [ngClass]="selectedTab() === 'impossible' ? 'active' : ''"
                (click)="selectTab('impossible')">
                Impossible Tunings ({{ impossibleList().length }})
            </button>
        </div>

        <div class="cards-carousel">
            <button class="nav-btn nav-btn-left" (click)="prevPage()"
                [disabled]="activeLength() <= pageSize || currentPage() === 0">
                <i class="bi bi-chevron-left"></i>
            </button>

            <div class="cards-grid">
                @if (selectedTab() === 'completed') {
                @for (completedTuning of pagedCompletedList(); track $index) {

                <div class="tuning-details"
                     [appFocusedFile]="+completedTuning.pureOriginalMatchingDetailsId === focusedMatchingId()"
                     [attr.data-matching-id]="completedTuning.pureOriginalMatchingDetailsId" [ngClass]="{
        'highlight-card':
          completedTuning.tuningName === versionNameParam() ||
          isMatchingIdHighlighted(+completedTuning.pureOriginalMatchingDetailsId),
        'highlighted-queue-card': checkIfVersionIsInQueue(
          completedTuning.tuningName
        )
      }">
                    <div class="version-status-indicator" [ngClass]="+completedTuning.hitRate == 1 ? 'green' : ''"></div>
                    @if (checkIfVersionIsInQueue(completedTuning.tuningName)) {
                    <div class="queue-container">
                        <span>In Queue</span>
                    </div>
                    }
                    <div class="main-content-wrapper">
                        <div class="corners-wrapper">
                            <div class="left-corner-content">
                                <div class="checkbox-wrapper">
                                    <label>
                                        <input type="checkbox"
                                            [disabled]="isDisabledCheckbox(completedTuning.tuningName)"
                                            [checked]="completedTuning.enabled" (change)="
                    changeTuningStatus(
                      $event,
                      completedTuning.pureOriginalMatchingDetailsId,
                      completedTuning.tuningName
                    )
                  " class="custom-checkbox" />
                                        <span class="custom-checkmark"></span>
                                    </label>
                                    @if (isClaimedFile()) {
                                    <span class="tooltip-checkbox">Please claim the file</span>
                                    }
                                </div>
                            </div>
                            <div class="right-corner-content">
                                <div class="top-right-corner">
                                    <div class="main-content-header">
                                        <span class="tuning">Times requested:</span>
                                        <span class="tuning">{{ completedTuning.timesRequested }}</span>
                                    </div>
                                </div>
                                <div class="main-content-header">
                                    <div class="button-name-wrapper">
                                        <div class="tuning-name-button">
                                            <button (click)="
                      masterDetails(
                        +completedTuning.masterId,
                        completedTuning.tuningName
                      )
                    ">
                                                {{ completedTuning.versionWinOLSReference | shorten : 20 }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tuning-container">
                            <div class="tuning-title-name">
                                <span class="tuning-title">{{
                                    completedTuning.tuningName | shorten : 27
                                    }}</span>

                                <div class="tuning-comment-container">
                                    <span class="tuning-comment color">{{
                                        completedTuning.versionComment | shorten : 20
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="button-container-position">
                        <div class="buttons-container">
                            <div class="update-button-container">
                                <div class="buttons">
                                    <button class="r-btn" (click)="openFileUploadModal(completedTuning.tuningName)"
                                        [disabled]="isClaimedFile()"
                                        [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''">
                                        <span class="btn-text-update">Update</span>
                                    </button>
                                </div>
                            </div>
                            <div class="buttons-delete">
                                <button class="r-btn" (click)="
                deleteVersionTuning(
                  'pureOriginalVersions',
                  +completedTuning.pureOriginalMatchingDetailsId,
                  'PURE_ORIGINAL_MATCHING'
                )
              " [disabled]="
                isClaimedFile() ||
                pureOriginalsService.isDeletingMap()[
                  +completedTuning.pureOriginalMatchingDetailsId
                ]
              " [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''">
                                    <span class="btn-text-delete">Delete</span>
                                </button>
                            </div>
                        </div>
                        <div class="download-buttons-container">
                            <button (click)="
              downloadVersionFile(
                +completedTuning.pureOriginalMatchingDetailsId,
                completedTuning.versionWinOLSReference,
                'PURE_ORIGINAL_MATCHING'
              )
            " [disabled]="
              isDownloadInProgress(
                +completedTuning.pureOriginalMatchingDetailsId
              )
            ">
                                <span class="btn-text">Download</span>
                            </button>
                            @if (completedTuning.versionId) {
                            <button class="r-btn attachment-btn" (click)="toggleAttachments('completed', $index)"
                                    [class.active]="expandedAttachmentIndex() === 'completed-' + $index">
                                <i class="bi bi-paperclip"></i>
                                @if (attachmentCounts().get(+completedTuning.versionId) > 0) {
                                    <span class="attachment-badge">{{ attachmentCounts().get(+completedTuning.versionId) }}</span>
                                }
                            </button>
                            }
                        </div>
                    </div>
                    @if (expandedAttachmentIndex() === 'completed-' + $index) {
                        <app-file-attachments-container
                            entityType="version"
                            [entityId]="+completedTuning.versionId">
                        </app-file-attachments-container>
                    }
                </div>
                }
                } @else if (selectedTab() === 'partial') {
                @for (partialTuning of pagedPartialList(); track $index) {
                <div class="tuning-details"
                     [appFocusedFile]="+partialTuning.pureOriginalMatchingDetailsId === focusedMatchingId()"
                     [attr.data-matching-id]="partialTuning.pureOriginalMatchingDetailsId" [ngClass]="{
        'highlight-card':
          partialTuning.tuningName === versionNameParam() ||
          isMatchingIdHighlighted(+partialTuning.pureOriginalMatchingDetailsId),
        'highlighted-queue-card': checkIfVersionIsInQueue(
          partialTuning.tuningName
        )
      }">
                    <div class="version-status-indicator" [ngClass]="+partialTuning.hitRate < 1 ? 'orange' : ''"></div>
                    @if (checkIfVersionIsInQueue(partialTuning.tuningName)) {
                    <div class="queue-container">
                        <span>In Queue</span>
                    </div>
                    }

                    <div class="main-content-wrapper">
                        <div class="corners-wrapper">
                            <div class="left-corner-content">
                                <div class="checkbox-wrapper">
                                    <label>
                                        <input type="checkbox" [disabled]="isDisabledCheckbox(partialTuning.tuningName)"
                                            [checked]="partialTuning.enabled" (change)="
                    changeTuningStatus(
                      $event,
                      partialTuning.pureOriginalMatchingDetailsId,
                      partialTuning.tuningName
                    )
                  " [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''" class="custom-checkbox" />
                                        <span class="custom-checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="right-corner-content">
                                <div class="top-right-corner">
                                    <div class="main-content-header">
                                        <span class="tuning">Times requested:</span>
                                        <span class="tuning">{{ partialTuning.timesRequested }}</span>
                                    </div>
                                    <div class="main-content-header">
                                        <div class="button-name-wrapper">
                                            <div class="tuning-name-button">
                                                <button (click)="
                        masterDetails(
                          +partialTuning.masterId,
                          partialTuning.tuningName
                        )
                      ">
                                                    {{ partialTuning.versionWinOLSReference | shorten : 20 }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tuning-container">
                            <div class="tuning-title-name">
                                <span class="tuning-title">{{
                                    partialTuning.tuningName | shorten : 20
                                    }}</span>
                            </div>
                            <div class="tuning-comment-wrapper">
                                <div class="tuning-comment-container">
                                    <span class="tuning-comment color">{{
                                        partialTuning.versionComment | shorten : 20
                                        }}</span>
                                </div>
                                <div class="percentage-container" [ngClass]="+partialTuning.hitRate < 1 ? 'orange' : ''">
                                    <span class="number">{{
                                        (+partialTuning.hitRate * 100).toFixed(2)
                                        }}</span>
                                    <i class="bi bi-percent number"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="button-container-position">
                        <div class="buttons-container">
                            <div class="upload-button-container">
                                <div class="buttons">
                                    <button class="r-btn"
                                            (click)="openFileUploadModal(partialTuning.tuningName)"
                                            [disabled]="isClaimedFile() || +partialTuning.hitRate >= 1"
                                            [style.visibility]="+partialTuning.hitRate < 1 ? 'visible' : 'hidden'"
                                            [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''">
                                        <span class="btn-text-update">Upload</span>
                                    </button>
                                </div>
                            </div>

                            <div class="buttons-delete">
                                <button class="r-btn" (click)="
                deleteVersionTuning(
                  'pureOriginalVersions',
                  +partialTuning.pureOriginalMatchingDetailsId,
                  'PURE_ORIGINAL_MATCHING'
                )
              " [disabled]="
                isClaimedFile() ||
                pureOriginalsService.isDeletingMap()[
                  +partialTuning.pureOriginalMatchingDetailsId
                ]
              " [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''">
                                    <span class="btn-text-delete">Delete</span>
                                </button>
                            </div>

                            <div class="buttons-ai">
                                <button class="r-btn ai-send-btn"
                                        (click)="sendToAiFinisher(partialTuning.tuningName)"
                                        [disabled]="aiSeedInFlight().has(partialTuning.tuningName)"
                                        [matTooltip]="'Send to AI Finisher — the AI completes this partial tune in WinOLS and queues the result for engineer review'">
                                    <i class="bi bi-robot"></i>
                                    <span class="btn-text-ai">AI</span>
                                </button>
                            </div>
                        </div>

                        <div class="download-buttons-container">
                            <button (click)="
              downloadVersionFile(
                +partialTuning.pureOriginalMatchingDetailsId,
                partialTuning.versionWinOLSReference,
                'PURE_ORIGINAL_MATCHING'
              )
            " [disabled]="
              isDownloadInProgress(+partialTuning.pureOriginalMatchingDetailsId)
            ">
                                <span class="btn-text">Download</span>
                            </button>
                            @if (partialTuning.versionId) {
                            <button class="r-btn attachment-btn" (click)="toggleAttachments('partial', $index)"
                                    [class.active]="expandedAttachmentIndex() === 'partial-' + $index">
                                <i class="bi bi-paperclip"></i>
                                @if (attachmentCounts().get(+partialTuning.versionId) > 0) {
                                    <span class="attachment-badge">{{ attachmentCounts().get(+partialTuning.versionId) }}</span>
                                }
                            </button>
                            }
                        </div>
                    </div>
                    @if (expandedAttachmentIndex() === 'partial-' + $index) {
                        <app-file-attachments-container
                            entityType="version"
                            [entityId]="+partialTuning.versionId">
                        </app-file-attachments-container>
                    }
                </div>
                }
                } @else if (selectedTab() === 'missing') {
                @for (missing of pagedMissingList(); track $index) {

                <div class="tuning-details" [ngClass]="{
        'highlight-card': missing.tuningName === versionNameParam(),
        'highlighted-queue-card': checkIfVersionIsInQueue(missing.tuningName)
      }">
                    <div class="version-status-indicator red"></div>
                    @if (checkIfVersionIsInQueue(missing.tuningName)) {
                    <div class="queue-container">
                        <span>In Queue</span>
                    </div>
                    }
                    <div class="main-content-wrapper">
                        <div class="corners-wrapper">
                            <div class="left-corner-content">
                                <div class="checkbox-wrapper">
                                    <label>
                                        <input type="checkbox" [disabled]="isDisabledCheckbox(missing.tuningName)"
                                            [checked]="missing.enabled" (change)="
                    changeTuningStatus($event, missing.id, missing.tuningName)
                  " class="custom-checkbox" [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''" />
                                        <span class="custom-checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="right-corner-content">
                                <div class="top-right-corner">
                                    <div class="main-content-header">
                                        <span class="tuning">Times Requested:</span>
                                        <span class="tuning">{{ missing.timesRequested }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tuning-container">
                            <div class="tuning-title-name">
                                <span class="tuning-title-missing">{{
                                    missing.tuningName | shorten : 20
                                    }}</span>
                            </div>
                            <div class="missing-percentage-container">
                                <span class="numbers">0</span>
                                <i class="bi bi-percent"></i>
                            </div>
                        </div>
                    </div>

                    <div class="button-container-position">
                        <div class="missing-buttons-container">
                            <div class="missing-button-upload">
                                <div class="buttons">
                                    <button class="r-btn" (click)="openFileUploadModal(missing.tuningName)"
                                        [disabled]="isClaimedFile()"
                                        [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''">
                                        <span class="btn-text-update">Upload</span>
                                    </button>
                                </div>
                            </div>
                            <div class="buttons-delete">
                                <button class="r-btn" (click)="
                deleteVersionTuning(
                  'pureOriginalMissingVersions',
                  +missing.id,
                  'PURE_ORIGINAL_MISSING_VERSIONS'
                )
              " [disabled]="
                isClaimedFile() ||
                pureOriginalsService.isDeletingMap()[+missing.id]
              " [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''">
                                    <span class="btn-text-delete">Delete</span>
                                </button>
                            </div>
                        </div>
                        <div class="download-buttons-container">
                            <button (click)="
              downloadMissingTuning(
                +missing.id,
                pureOriginalsService.pureOriginalDetails().winOlsReference,
                'PURE_ORIGINAL_MISSING_VERSIONS'
              )
            " [disabled]="isDownloadInProgress(+missing.id)">
                                <span class="btn-text">Download</span>
                            </button>
                        </div>
                    </div>
                </div>
                }
                } @else {
                @for (impossible of pagedImpossibleList(); track $index) {
                <div class="tuning-details" [appFocusedFile]="+impossible.id === focusedMatchingId()"
                     [attr.data-matching-id]="impossible.id">
                    <div class="version-status-indicator grey"></div>
                    <div class="main-content-wrapper">
                        <div class="corners-wrapper">
                            <div class="left-corner-content">
                                <div class="checkbox-wrapper-impossible">
                                    <label>
                                        <input type="checkbox"
                                               [disabled]="isDisabledCheckbox(impossible.tuningName)"
                                               [checked]="impossible.enabled"
                                               [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''"
                                               (change)="changeTuningStatus($event, impossible.id, impossible.tuningName)"
                                               class="custom-checkbox-impossible" />
                                        <span class="custom-x"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="right-corner-content">
                                <div class="top-right-corner">
                                    <div class="main-content-header">
                                        <span class="tuning">Times Requested:</span>
                                        <span class="tuning">{{ impossible.timesRequested }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tuning-container">
                            <div class="tuning-title-name">
                                <span class="tuning-title">{{ impossible.tuningName | shorten : 20 }}</span>
                            </div>
                            <div class="tuning-comment-wrapper">
                                <div class="tuning-comment-container">
                                    <span class="tuning-comment color"> </span>
                                </div>
                                <div class="percentage-container">
                                    <span class="number">0</span>
                                    <i class="bi bi-percent number"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="button-container-position">
                        <div class="buttons-container">
                            <div class="upload-button-container">
                                <div class="buttons">
                                    <button class="r-btn ghost" type="button" disabled>
                                        <span class="btn-text-update">Upload</span>
                                    </button>
                                </div>
                            </div>

                            <div class="buttons-delete">
                                <button class="r-btn" (click)="
              deleteVersionTuning(
                'pureOriginalImpossibleTunings',
                +impossible.id,
                'PURE_ORIGINAL_MISSING_VERSIONS'
              )
            " [disabled]="
              isClaimedFile() ||
              pureOriginalsService.isDeletingMap()[+impossible.id]
            " [matTooltip]="isClaimedFile() ? 'Please claim the file' : ''">
                                    <span class="btn-text-impossible">Delete</span>
                                </button>
                            </div>
                        </div>

                        <div class="download-buttons-container">
                            <button class="ghost" type="button" disabled>
                                <span class="btn-text">Download</span>
                            </button>
                        </div>
                    </div>
                </div>
                }
                }
            </div>

            <button class="nav-btn nav-btn-right" (click)="nextPage()"
                [disabled]="activeLength() <= pageSize || currentPage() >= totalPages() - 1">
                <i class="bi bi-chevron-right"></i>
            </button>
        </div>

        @if (pureOriginalsService.newVersions().length > 0) {
        <div class="new-versions-row">
            <h3 class="new-versions-title">In Queue ({{ pureOriginalsService.newVersions().length }})</h3>
            <div class="new-versions-chips">
                @for (version of pureOriginalsService.newVersions(); track $index) {
                <span class="queue-chip">{{ version | shorten : 24 }}</span>
                }
            </div>
        </div>
        }
    </div>
</div>
